import { Suspense, lazy } from 'react';

import * as Sentry from '@sentry/react';
import { Root, createRoot } from 'react-dom/client';
import { Controller } from 'stimulus';

import { AppProps } from '../../apps/RetailApp';
import FullPageLoader from '../../Shared/components/FullPageLoader';

export default class extends Controller {
  root: Root;

  connect() {
    const App = Sentry.withProfiler(
      lazy(() => import('../../apps/RetailApp')),
      { name: 'RetailApp' }
    );
    const initialProps = JSON.parse(this.data.get('initial-props') || '{}') as AppProps;

    if (!this.root) {
      this.root = createRoot(this.element);
    }
    this.root.render(
      <Suspense fallback={<FullPageLoader />}>
        <App {...initialProps} />
      </Suspense>
    );
  }
}
